import { useFetch } from '@reveni-io/reveni-ui'

import inventoryServices from '@/inventory/services/services'

const useProductInventoryItems = ({ storeId }) => {
  const { data, loading, fetchData } = useFetch(inventoryServices.getProductsInventoryItems, {
    doInitialRequest: false,
    params: { storeId },
  })

  return {
    productsInventoryItems: data?.results || [],
    next: data?.next || null,
    previous: data?.previous || null,
    loading,
    getProductsInventoryItems: fetchData,
  }
}

export default useProductInventoryItems
